import { types } from "../types/types";
import { fetchConToken } from '../helpers/fetch';
import { openModal, openModalBottom } from './ui';

export const startLoadingVacacionesLogsProfesional = (profesionalId, empresa, limit = 50, skip = 0) => {
    return async (dispatch, getState) => {
        try {
            const url = `vacaciones/profesional/${profesionalId}/logs?empresa=${empresa || ''}&limit=${limit}&skip=${skip}`;
            const resp = await fetchConToken(url, {}, 'GET');
            const body = await resp.json();
            
            if (body.ok) {
                const currentState = getState();
                const currentLogs = currentState.vacacionesLogs.logsProfesional || [];
                const newLogs = body.logs || [];
                
                const logsToSet = skip > 0 ? [...currentLogs, ...newLogs] : newLogs;
                
                dispatch(setVacacionesLogsProfesional(logsToSet, body.total || 0, body.pagination));
            } else {
                dispatch(openModal({
                    title: 'Error',
                    text: [body.msg || 'Error al cargar los logs'],
                    buttonText: 'Cerrar'
                }));
            }
        } catch (error) {
            console.error('Error al cargar logs de vacaciones del profesional:', error);
            dispatch(openModal({
                title: 'Error',
                text: ['Error al conectar con el servidor'],
                buttonText: 'Cerrar'
            }));
        }
    }
};

export const setVacacionesLogsProfesional = (logs, total, pagination = null) => ({
    type: types.vacacionesLogsProfesionalLoad,
    payload: {
        logs,
        total,
        pagination
    }
});

export const startDeletingVacacionesLogsProfesional = (profesionalId, empresa) => {
    return async (dispatch) => {
        try {
            const url = `vacaciones/profesional/${profesionalId}/logs${empresa ? `?empresa=${empresa}` : ''}`;
            const resp = await fetchConToken(url, {}, 'DELETE');
            const body = await resp.json();
            
            if (body.ok) {
                dispatch(openModalBottom({
                    text: [body.msg || 'Logs eliminados correctamente'],
                    timeOut: 3
                }));
                dispatch(startLoadingVacacionesLogsProfesional(profesionalId, empresa));
            } else {
                dispatch(openModal({
                    title: 'Error',
                    text: [body.msg || 'Error al eliminar los logs'],
                    buttonText: 'Cerrar'
                }));
            }
        } catch (error) {
            console.error('Error al eliminar logs de vacaciones del profesional:', error);
            dispatch(openModal({
                title: 'Error',
                text: ['Error al conectar con el servidor'],
                buttonText: 'Cerrar'
            }));
        }
    }
};
